
// Configure webpack for the site -
console.log('Configuring webpack');
console.log('Site configuration: ' + JSON.stringify(config));
console.log('window.location.href: ' + window.location.href);

// There are some benefits to loading the CSS files via require() but for now this is commented out.
// require('../static/css/bootstrap-3.3.7-dist/css/bootstrap.css')
// require('../static/css/site.css')

//console.log('loading Vue stuff');

import vMediaQuery from 'v-media-query'
import VeeValidate from 'vee-validate'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import Dropzone from 'vue2-dropzone'
import ImageUploader from 'vue-image-upload-resize'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import dataURLtoBlob from 'blueimp-canvas-to-blob'
import Lightbox from 'vue-pure-lightbox'
import AWS from 'aws-sdk'
import base64 from 'base-64'
import CryptoJS from 'crypto-js'

import Store from './store'
import User from './services/user'

// The Vue build version to load with the `import` command (runtime-only or standalone) has been set in webpack.base.conf with an alias.
let Vue = require('vue')
let VueRouter = require('vue-router')
let App = require('./App')
let Home = require('./components/Home')
let Login = require('./components/Login')
let WorkOrder = require('./components/WorkOrder')
let Labor = require('./components/Labor')
let Equipment = require('./components/Equipment')
let Materials = require('./components/Materials')
let Notes = require('./components/Notes')
let Photos = require('./components/Photos')
let Dev = require('./components/Dev')
let config = require('./config/site.json')



// use vue router for routing - this installs <router-view> and <router-link>
// it also injects $router and $route to all router-enabled child components.
Vue.use(VueRouter)

Vue.use(require('vue-moment'));

Vue.use(Lightbox)

// use media query plugin - this injects $mq to all components, default 'tablet' size.
Vue.use(vMediaQuery, {
  variables: {
    tablet: 768
  }
})

Vue.use(ElementUI, { locale })


// simple form validator plugin 
Vue.use(VeeValidate)

Vue.use(AWS)

Vue.use(VueResource)

// filters  
Vue.use(Vue2Filters)

Vue.use(base64)
Vue.use(CryptoJS)

// define the route components
Vue.component('App', App)
Vue.component('Home', Home)
Vue.component('Login', Login)
Vue.component('WorkOrder', WorkOrder)
Vue.component('Labor', Labor)
Vue.component('Equipment', Equipment)
Vue.component('Materials', Materials)
Vue.component('Notes', Notes)
Vue.component('Photos', Photos)

let routes = [
        { path: '/', component: Home },
        { path: '/login', component: Login },
        { path: '/workorder/:id', component: WorkOrder },
        { path: '/workorder/labor/:id', component: Labor},
        { path: '/workorder/equipment/:id', component: Equipment},
        { path: '/workorder/material/:id', component: Materials},
        { path: '/workorder/notes/:id', component: Notes},
        { path: '/workorder/photos/:id', component: Photos},
        { path: '/dev', component: Dev}
]

const router = new VueRouter({
    mode: 'hash',
    forceRefresh : true,
    base: window.location.href,
    routes
  })

router.beforeEach((to, from, next) => {
  Store.redirect = ''
  console.log('Router transition. To: ' + JSON.stringify(to.fullPath) + ' from: ' + JSON.stringify(from.fullPath))

  try {
    if(to.fullPath == "/login" || User.auth) {
      next()
    } else {
      let redirectToLogin = () => {
        console.log('Need to redirect to login due to lack of auth. To = ' + JSON.stringify(to.fullPath))
        Store.redirect = to
        router.push('/login')
      }

      if (User.hasStoredCreds()) {
        console.log('Have stored creds. Attempting to use them')
        User.populateFromStorage()
        User.login((err, res) => {
          // Success -- go to the next route.
          console.log('Login with stored creds successful. Transitioning.')
          next()
        },
        (err, res) => {
          // Failure
          console.log('Failure with stored creds. Redirecting to login screen.')
          redirectToLogin()
        })
      } else {
        console.log('No stored creds. Going to login screen.')
        redirectToLogin()
      }
    }
  } catch (e) {
    // transition.abort()
    console.error('Exception on route transition', e)
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  el: '#app',
  render: h=>h(App)
  // components: { App }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js